import { Component } from '@angular/core';
import {ButtonComponent} from "../../components/ui/button/button.component";
import {ActivatedRoute, Router, RouterOutlet} from "@angular/router";
import {TabComponent} from "../../components/ui/tab/tab.component";
import {TabsComponent} from "../../components/ui/tabs/tabs.component";
import {TitleComponent} from "../../components/ui/title/title.component";
import {TranslateModule} from "@ngx-translate/core";
import {BackButtonComponent} from "../../components/ui/back-button/back-button.component";
import {ModalService} from "../../services/modal.service";
import {DeleteConfirmModalComponent} from "../../components/modals/delete-confirm-modal/delete-confirm-modal.component";
import {EditProjectModalComponent} from "../../components/modals/edit-project-modal/edit-project-modal.component";
import {firstValueFrom, map} from "rxjs";
import {AsyncPipe, NgIf} from "@angular/common";
import {ProjectService} from "../../services/project.service";
import {ProjectAdminAccessDirective} from "../../directives/project-admin-access.directive";

@Component({
  selector: 'app-project-detail',
  standalone: true,
  imports: [
    ButtonComponent,
    RouterOutlet,
    TabComponent,
    TabsComponent,
    TitleComponent,
    TranslateModule,
    BackButtonComponent,
    AsyncPipe,
    ProjectAdminAccessDirective,
    NgIf
  ],
  templateUrl: './project-detail.component.html',
  styleUrl: './project-detail.component.scss'
})
export class ProjectDetailComponent {
  project$ = this.route.data.pipe(map(data => data['project']));

  constructor(private modalService: ModalService, private route: ActivatedRoute, private router: Router, private projectService: ProjectService) {
  }

  async deleteProject() {
    const project = await firstValueFrom(this.project$);
    this.modalService.open(DeleteConfirmModalComponent, {
      data: {
        type: 'page.project-detail.delete-project.entity',
        name: project.name,
        confirm: async () => {
          await firstValueFrom(this.projectService.delete(project));
          this.router.navigate(['panel', 'projects']);
        },
      }
    });
  }

  async editProject() {
    this.modalService.open(EditProjectModalComponent, {
      data: {
        project: await firstValueFrom(this.project$),
      }
    });
  }
}
